export default {
  ScanNotReadable: 'The document was blurred, parts were cut off, or was not readable due to glare',
  ScanNotUploaded: 'A document was uploaded, but it was not an ID',
  ScanIdTypeNotSupported: 'An ID was uploaded, but it is not a form of ID we accept',
  ScanNameMismatch: 'The name on the ID does not match the name on the account',
  default: 'Please try again with a different document',
};



// WEBPACK FOOTER //
// ./src/data/static/documentRejectionMessages.js